import React, { useRef } from "react";
import { Col, Row } from "antd";
import { Typography, Button, Form } from "antd";
import { Select } from "antd";
import CustomerTable from "./CustomerTable";
import CraeteCustomer from "./CraeteCustomer";
import { useReactToPrint } from "react-to-print";
import ContractGrid from "./ContractGrid";

const { Option } = Select;
const { Title } = Typography;

export default function ContractCustomer({ search }) {
  const printRef = useRef(null);
  const [form] = Form.useForm();
  const [success, setSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [taskType, setTaskType] = React.useState("");
  const [constructionType, setConstructionType] = React.useState("");
  const [priority, setPriority] = React.useState("");

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
        @page { size: a4 landscape !important; }
    `
  });

  return (
    <div
      style={{
        paddingLeft: "20px",
        paddingRight: "20px",
      }}
    >
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <ContractGrid
            printRef={printRef}
            setLoading={setLoading}
            loading={loading}
            setSuccess={setSuccess}
            success={success}
            taskType={taskType}
            priority={priority}
            constructionType={constructionType}
            search={search}
          />
        </Col>
      </Row>
    </div>
  );
}
